<template>
<div>
<font-awesome-icon @click="goOut" icon="sign-out-alt" class="cicon logoutbtn" />   
<form id="logout-form" action="/logout" method="POST" style="display: none;">
	<input type="hidden" name="_token" id="custom_token" :value="csrftoken">
</form>
</div>
</template>
<script>
export default {
    name: "custom_logout",
      data() {
        return {
            csrftoken: ""
        };
    },
    created(){    
        try{
            if(document.head.querySelector('meta[name="csrf-token"]').content){
                this.csrftoken = document.head.querySelector('meta[name="csrf-token"]').content
            } 
        }catch(e){
            console.log(e)
        }             
    },
    methods: {
        goOut(){
            document.getElementById('logout-form').submit();
        }
    }    
}
</script>
<style scoped>
.logoutbtn{
    margin:0 10px;
}
</style>